import {
  getCurrency,
  getPrizeTable,
  getPurse,
} from "@/utils/tournaments";
import { Tournament } from "@/types/tournament";

interface PrizeListProps {
  tournament: Tournament;
}

const PrizeList = ({ tournament }: PrizeListProps) => {
  const playersCount =
    tournament?.participants?.allInvitationsCount -
    tournament?.participants?.declinedCount -
    tournament?.participants?.withdrawnCount;

  const isFinalSeason2 =
    tournament?.season === 2 &&
    tournament?.name?.toLowerCase()?.includes("final");

  const prizeTable = getPrizeTable(
    tournament?.season,
    tournament?.id,
    tournament?.name,
    playersCount
  );
  const currency = getCurrency(tournament?.season, tournament?.name);

  return (
    <div className="grid-container pt-14 lg:pt-[120px] pb-14 lg:pb-[120px]">
      <div className="col-start-1 col-span-4 lg:col-start-5 lg:col-span-8 2xl:col-start-9 2xl:col-span-16">
        <div className="col-start-1 col-span-4 lg:col-start-6 lg:col-span-6 2xl:col-start-12 2xl:col-span-10 mb-16">
          <h1 className="text-center">Stroke play</h1>
        </div>
        <div className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full mb-[50px]">
          <div className="flex flex-col gap-2.5">
            <span className="text-4xl 2xl:text-6xl">
              {currency}
              {getPurse(
                tournament?.season,
                tournament?.id,
                tournament?.name,
                playersCount
              ).toLocaleString("en-US")}
            </span>
            <span className="text-xl text-tm-c-gray-300">Purse</span>
          </div>
          <div className="flex flex-col gap-2.5">
            <span className="text-4xl 2xl:text-6xl">
              {isFinalSeason2 ? 100 : playersCount}
            </span>
            <span className="text-xl text-tm-c-gray-300">Players</span>
          </div>
        </div>
      </div>
      <div className="col-start-1 col-span-4 lg:col-start-5 lg:col-span-8 2xl:col-start-9 2xl:col-span-16">
        <ol className="list-none m-0 p-0 bg-tm-c-gray-950 rounded overflow-hidden">
          <li className="flex even:bg-[rgba(65,65,65,0.2)] first:bg-tm-c-gray-700 [&>*]:w-full [&>*]:block [&>*]:text-center [&>*]:py-[10px] [&>*]:px-0 [&>*]:text-xl">
            <span>Position</span>
            <span>Prize money</span>
          </li>
          {prizeTable?.map(
            (item: number, index: number) =>
              item > 0 && (
                <li
                  key={index}
                  className="flex even:bg-[rgba(65,65,65,0.2)] first:bg-tm-c-gray-700 [&>*]:w-full [&>*]:block [&>*]:text-center [&>*]:py-[10px] [&>*]:px-0 [&>*]:text-xl"
                >
                  <span>{index + 1}</span>
                  <span>
                    {currency}
                    {item.toLocaleString("en-US")}
                  </span>
                </li>
              )
          )}
          {prizeTable?.indexOf(0) !== -1 && (
            <li className="flex even:bg-[rgba(65,65,65,0.2)] first:bg-tm-c-gray-700 [&>*]:w-full [&>*]:block [&>*]:text-center [&>*]:py-[10px] [&>*]:px-0 [&>*]:text-xl">
              <span>
                {prizeTable.indexOf(0) + 1}
                ...
                {prizeTable?.length}
              </span>
              <span>{currency}0</span>
            </li>
          )}
        </ol>
      </div>
    </div>
  );
};

export default PrizeList;
